import React, { useEffect, useState } from 'react';
import { SidebarContainer } from '@arema/components';
import { useLocation, useParams } from 'react-router-dom';
import { NotFound } from '../../components';
import { Header, Image, Placeholder } from 'react-frontier';
import { CDN_URL, PLACEHOLDER_IMG, PAGE_PUBLIC } from '../../ReportsConfig';
import { DateShortInfo, EventShortInfo } from '../../ReportsClasses';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import API from '../../ReportsAPI';

import EventStatsDashboard from './EventStatsDashboard';
import EventStatsDates from './EventStatsDates';
import EventStatsPayout from './EventStatsPayout';
import EventStatsReports from './EventStatsReports';
import DateStatsDashboard from '../dates/DateStatsDashboard';
import DateStatsSales from '../dates/DateStatsSales';
import DateStatsUses from '../dates/DateStatsUses';

import '../../style/event_view.scss';

var EventStatsContainer = ()=>{
	var { t } = useTranslation();
	var [event, setEvent] = useState<EventShortInfo>(null);
	var [date, setDate] = useState<DateShortInfo>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var location = useLocation();
	var params = useParams<{ event_id: string, date_id: string }>();
	
	var event_id = parseInt(params.event_id);
	var date_id = parseInt(params.date_id);

	useEffect(()=>{
		if(!event_id || Number.isNaN(event_id)) return;
		API.getEventInfo(event_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setEvent(res.data);
		}).catch(err=>{
			setLoadError(t('common.error_code', { type: 'cargando el evento', code: 'LCL-1' }));
		});
	}, []);

	useEffect(()=>{
		if(date && date.date_id!==date_id) setDate(null);
		if(!date_id || Number.isNaN(date_id)) return;
		API.getDateInfo(date_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setDate(res.data);
		}).catch(err=>{
			setLoadError(t('common.error_code', { type: 'cargando la fecha', code: 'LCL-2' }));
		});
	}, [date_id])

	useEffect(()=>{
		setLoadError(null);
	}, [location])

	if(!event_id || Number.isNaN(event_id)) return <NotFound />
	if(loadError) return <Header text={t('common.error')} subtext={loadError} iconName='face-frown-open' />
	if(!event) return <Header loading text={t('event_container.loading')} />

	return <SidebarContainer
		className='ar event-view-screen'
		routeParams={{ event, event_id, date }}
		routes={[
			{ url: `/miseventos/${event_id}`, component: EventStatsDashboard },
			{ url: `/miseventos/${event_id}/liquidaciones`, component: EventStatsPayout },
			{ url: `/miseventos/${event_id}/reports`, component: EventStatsReports },
			{ url: `/miseventos/${event_id}/funciones`, component: EventStatsDates },
			{ url: `/miseventos/${event_id}/funciones/${date_id}`, component: DateStatsDashboard },
			{ url: `/miseventos/${event_id}/funciones/${date_id}/avance`, component: DateStatsSales },
			{ url: `/miseventos/${event_id}/funciones/${date_id}/accesos`, component: DateStatsUses },
			{ url: `/miseventos/${event_id}/funciones/${date_id}/reports`, component: EventStatsReports },
		]}
		getTitle={()=>event.event_name}
		missingComponent={<NotFound />}
		contentHeader={(!!event && !!date_id && !!date) && (
			<Header text={event.event_name} subtext={t('dates.header_subtitle', { date: moment.unix(date.date).format('DD/MMM/YY HH:mm') })} style={{ marginTop: 15 }} />
		)}
		sidebarHeader={<div className='head item'>
			<div className="image">
				{!!event && (
					<Image src={`${CDN_URL}/events/${event.event_id}/200.webp`} alt={event?.event_name} fallback={PLACEHOLDER_IMG} />
				)}
			</div>
			{!event ? (
				<Placeholder width={100} height={24} />
			) : (
				<div className="name">{event.event_name}</div>
			)}
		</div>}
	>
		<SidebarContainer.Divider />
		<SidebarContainer.Item to={`/miseventos/${event_id}`} iconName='chart-simple' text={t('event_container.items.dashboard')} />
		<SidebarContainer.Item to={`/miseventos/${event_id}/funciones`} iconName='calendar-day' text={t('event_container.items.dates')} />
		{!!date_id && (
			<SidebarContainer.Item subitem selectable={false} className='text' style={{ marginTop: 5 }}>
				{t('event_container.date')}: {date ? (
					moment.unix(date.date).format('DD/MMM/YY HH:mm')
				) : (
					<Placeholder style={{ display: 'inline-block', marginLeft: 2 }} width={50} />
				)}
			</SidebarContainer.Item>
		)}
		{!!date_id && <SidebarContainer.Item subitem to={`/miseventos/${event_id}/funciones/${date_id}`} text={t('event_container.date_items.dashboard')} />}
		{!!date_id && <SidebarContainer.Item subitem to={`/miseventos/${event_id}/funciones/${date_id}/avance`} text={t('event_container.date_items.sales')} />}
		{!!date_id && <SidebarContainer.Item subitem to={`/miseventos/${event_id}/funciones/${date_id}/accesos`} text={t('event_container.date_items.access')} />}
		{!!date_id && <SidebarContainer.Item subitem to={`/miseventos/${event_id}/funciones/${date_id}/reports`} text={t('event_container.date_items.reports')} />}
		<SidebarContainer.Item to={`/miseventos/${event_id}/liquidaciones`} iconName='money-bill-wave' text={t('event_container.items.payouts')} />
		<SidebarContainer.Item to={`/miseventos/${event_id}/reports`} iconName='file-download' text={t('event_container.items.reports')} />
		<SidebarContainer.Divider />
		<SidebarContainer.Item to={`${PAGE_PUBLIC}/e/${event_id}`} target='_blank' iconName='eye' text={t('event_container.items.view_event')} />
	</SidebarContainer>
}

export default EventStatsContainer;